import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {Construct} from 'classes/construct';
import {ContentUsage, Dialog} from 'classes/dialog';
import {TargetGroup} from 'shared/models/target-groups/target-group';
import {DialogsDetailsRepository} from '../repositories/dialogs-details.repository';

@Injectable()
export class DialogsDetailsService {

  constructor(private dialogsDetailsRepository: DialogsDetailsRepository) { }

  public getDialogById(id: number): Observable<Dialog> {
    return this.dialogsDetailsRepository.getDialogById(id);
  }

  public getAllTargetGroups(): Observable<Array<TargetGroup>> {
    return this.dialogsDetailsRepository.getAllTargetGroups();
  }

  public saveDialog(dialog: Dialog): Observable<Dialog> {
    return this.dialogsDetailsRepository.saveDialog(dialog);
  }

  public updateDialog(dialog: Dialog): Observable<Dialog> {
    return this.dialogsDetailsRepository.updateDialog(dialog);
  }

  public getContentUsages(id: number): Observable<Array<ContentUsage>> {
    return this.dialogsDetailsRepository.getContentUsages(id);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dialogs/dialogs-details/services/dialogs-details.service.ts